import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AddToBasketButtonContent from '@/shared/form/AddToBasketButtonContent.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useProductDetailUpsell from '@/shared/product/upsell/useProductDetailUpsell';
import { useProductDetailUpsellAddToBasket } from '@/shared/product/upsell/useProductDetailUpsellAddToBasket';
import { ref } from 'vue';
import utilities from '@/shared/utilities.service';
import basketTrackingService from '@/shared/tracking/basket-tracking.service';
import { PurchaseOption } from '@/types/productServerApi';
import useProductClickAndCollect from '@/shared/product/purchase/ui/useProductClickAndCollect';
import useProductPurchase from '@/shared/product/purchase/ui/useProductPurchase';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailUpsellAddToBasket',
  props: {
    sku: null,
    quantity: null,
    upsellPurchaseOptions: null
  },
  setup(__props: any) {

const props = __props as {
    sku: string,
    quantity: number,
    upsellPurchaseOptions: PurchaseOption[];
}



const labels = useBlockLabels();
const { mainProductPurchaseOptionType, upsellItems } = useProductDetailUpsell();
const { storeId } = useProductClickAndCollect();
const getEndpoint = useProductDetailUpsellAddToBasket();
const { getPreferredPurchaseOptionType } = useProductPurchase();
const pending = ref<boolean>(false);
const minAnimationDuration: number = 2000;

const addToBasket = async() => {
    basketTrackingService.powerstep(props.sku, upsellItems.value);
    if (pending.value) {
        return;
    }
    pending.value = true;

    const purchaseOptionType = getPreferredPurchaseOptionType(props.upsellPurchaseOptions, mainProductPurchaseOptionType.value, storeId.value);
    if (purchaseOptionType !== null) {
        try {
            await Promise.all([
                getEndpoint(props.sku, purchaseOptionType, 1),
                utilities.delay(minAnimationDuration)]);
        } finally {
            pending.value = false;
        }
        const basketAnimationDuration = 500;
        await utilities.delay(basketAnimationDuration);
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      class: "mt-x2 c-button c-button--primary transition-colors",
      onClick: addToBasket
    }, [
      _createVNode(AddToBasketButtonContent, {
        pending: pending.value,
        "added-button-text": _unref(labels).addedToBasket,
        "default-button-text": _unref(labels).addToBasket
      }, null, 8, ["pending", "added-button-text", "default-button-text"])
    ])
  ]))
}
}

})